export default __webpack_public_path__ + "static/media/ISKO CLASS-7 EXAM PATTERN 2026-27.ce8555ea.pdf";